$(function () {
    $('.is-invalid').on('change', function() {
        $(this).removeClass('is-invalid');
        $(this).parents('.form-group').find('.error').remove();
    });
})
